import { render, staticRenderFns } from "./field.vue?vue&type=template&id=628fc024&scoped=true"
import script from "./field.vue?vue&type=script&lang=js"
export * from "./field.vue?vue&type=script&lang=js"
import style0 from "./field.vue?vue&type=style&index=0&id=628fc024&prod&scoped=true&lang=less"
import style1 from "./field.vue?vue&type=style&index=1&id=628fc024&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628fc024",
  null
  
)

export default component.exports